module.exports = __webpack_public_path__ + "static/media/EHRvideo_game.f7e19c10.png";